var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-button',{attrs:{"loading":_vm.submitLoading,"type":_vm.btnType},on:{"click":function($event){return _vm.applySubmit()}}},[_vm._v(_vm._s(_vm.$t(_vm.text)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }